import { Box, Card, Typography } from "@mui/material";
import { OptionItem } from "./OptionItem";
import { useEffect, useState } from "react";
import Users from "../../components/templates/AcessControl/Users";
import Cells from "../../components/templates/AcessControl/Cells";
import Roles from "../../components/templates/AcessControl/Roles";
import Profile from "../../components/templates/AcessControl/Profile";
import { useHistory, useLocation } from "react-router-dom";
import { ReactComponent as ProfileIcon } from "../../assets/styled-icons/Profile.svg";
import { ReactComponent as CellsIcon } from "../../assets/styled-icons/Cells.svg";
import { ReactComponent as RolesIcon } from "../../assets/styled-icons/Roles.svg";
import { ReactComponent as UsersIcon } from "../../assets/styled-icons/Users.svg";

export function AccessControl() {
  const history = useHistory();
  const location = useLocation<{ goToProfile?: number }>();
  const [optionActive, setOptionActive] = useState(0);

  useEffect(() => {
    if (location.state?.goToProfile) {
      setOptionActive(0);
    }
  }, [location.state]);

  function handleChangeActiveScreen(destination: string) {
    switch (destination) {
      case "users":
        setOptionActive(3);
        break;
      case "projects":
        history.push("/briefings");
        break;
    }
  }

  const options = [
    {
      title: "Perfil",
      icon: <ProfileIcon />,
      template: <Profile />,
    },
    {
      title: "Células",
      icon: <CellsIcon />,
      template: <Cells goTo={handleChangeActiveScreen} />,
    },
    {
      title: "Funções",
      icon: <RolesIcon />,
      template: <Roles />,
    },
    {
      title: "Usuários do sistema",
      icon: <UsersIcon />,
      template: <Users />,
    },
  ];
  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      flex={1}
      py={4}
      px={3}
      bgcolor={"#F9FCFF"}
    >
      <Box display={"flex"}>
        <Typography variant={"h5"}>Controle de Acesso</Typography>
      </Box>

      <Card
        sx={{
          display: "flex",
          mt: 4,
          boxShadow: "0px 4px 18px 0px #4B465C1A",
          overflow: "auto",
        }}
      >
        <Box
          display={"flex"}
          flexDirection={"column"}
          gap={1.5}
          px={"24px"}
          pt={"24px"}
          pb={"44px"}
          borderRight={"1px solid #DBDADE"}
        >
          {options.map((option, index) => (
            <OptionItem
              key={index}
              title={option.title}
              icon={option.icon}
              onClick={() => setOptionActive(index)}
              // lastUpdate={"última atualização 10/11 23h10"}
              isActive={optionActive === index}
            />
          ))}
        </Box>

        {options[optionActive] && options[optionActive].template}
      </Card>
    </Box>
  );
}
